import { useModal } from "../contexts";
import { BLOCK_ICON_MAP, BLOCK_NAME_MAP } from "../utils";
import ProLabel from "./ProLabel";
import PayWallModalPro from "./PayWallModalPro";
import BetaLabel from "./BetaLabel";
import { BasicWorkflow } from "../interfaces";

interface BaseProps {
  blockType: string;
  title: string;
  subtitle: string;
  onSelection: (blockType: string, file?: any, newWorkflow?: BasicWorkflow) => void;
  beta?: boolean;
}

interface NonProProps extends BaseProps {
  pro?: false;
}

interface ProProps extends BaseProps {
  pro: true;
  hasProFeature: boolean;
}


type Props = NonProProps | ProProps;

function WorkflowSelectButton(props: Props) {
  const { openModal } = useModal();

  function createBlock(newWorkflow?: BasicWorkflow) {
    if (props.pro && !props.hasProFeature)
      openModal(<PayWallModalPro />);
    else
      props.onSelection(props.blockType, newWorkflow);
  }

  function handleSelect() {
    createBlock();
  }

  return (
    <button className="flex flex-shrink-0 items-center border-2 border-gray-200 hover:border-blue rounded cursor-pointer p-4" onClick={handleSelect}>
      <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center"><img className="max-w-[40px] max-h-[40px] object-contain" src={BLOCK_ICON_MAP[props.blockType]} alt={BLOCK_NAME_MAP[props.blockType]} /></div>
      <div className="flex flex-col items-start text-left ml-4">
        <div className="font-gilroy font-semibold text-base text-gray-600">
          {props.title}
        </div>
        <div className="font-gilroy font-semibold text-xs text-gray-400">
          {props.subtitle}
        </div>
      </div>
      {props.pro &&
        <ProLabel />
      }
      {props.beta &&
        <BetaLabel />
      }
    </button>
  );
}

export default WorkflowSelectButton;
